export default "__VITE_ASSET__CPRl6ZCx__"